function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2a2 2 0 014 0v42h42a2 2 0 110 4H2a2 2 0 01-2-2V2zm15.9 25.28c.53.52 1.37.52 1.88 0l7.03-7.13 7.26 7.37L29.63 30c-1.26 1.28-.37 3.45 1.4 3.45h8.37c.74 0 1.33-.6 1.33-1.34v-8.5c0-1.8-2.14-2.7-3.4-1.42l-2.44 2.48-9.14-9.28a1.31 1.31 0 00-1.88 0l-7.02 7.13-4.3-4.35a1.31 1.31 0 00-1.87 0l-.94.95a1.36 1.36 0 000 1.9l6.17 6.26z"
})));